import { QuestionIndexing } from "@kunduz/data-access-qi-api";
import React, { ReactElement } from "react";
import styles from "./unlockedAnswerText.module.scss";

export const UnlockedAnswerText = (props: Props): ReactElement => {
  const { question } = props;

  if (!question?.structured_data?.acceptedAnswer?.text) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <p className={styles["answerText"]}>
      {question.structured_data?.acceptedAnswer?.text}
    </p>
  );
};

interface Props {
  question: QuestionIndexing.TrQiQuestion;
}
